export const TABLE_HEADERS = [
  { key: "itemName", placeholder: "Item Name", editable: true },
  { key: "displayName", placeholder: "Display Name", editable: true },
  { key: "description", placeholder: "Description", editable: true },
  { key: "comments", placeholder: "Comments", editable: true },
  { key: "sortSequence", placeholder: "Sort Sequence", editable: true },
  { key: "isActive", placeholder: "Is Active?", editable: false }, // This column will have the switch
  { key: "info", placeholder: "Info", editable: false }, // New column for info
  { key: "actions", placeholder: "Action" },
];
